import { render } from "./App.vue?vue&type=template&id=293b9942"
const script = {}

import "./App.vue?vue&type=style&index=0&id=293b9942&lang=css"
script.render = render

export default script